import { gql } from '@apollo/client';

export const MUTATE_EINSTELLUNGEN = gql`
  mutation dienstplan_updateSettings(
    $input: dienstplan_update_einstellungen_input!
  ) {
    dienstplan_update_einstellungen(input: $input) {
      bemerkung
    }
  }
`;
